export { default } from './useConfiguration';
export * from './useConfiguration';
